// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    HTML_SITEMAP_POST_PAGE_LOADING() {
      return {
        isLoading: true,
        htmlSitemapPostPage: action.htmlSitemapPostPage
      };
    },
    HTML_SITEMAP_POST_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const htmlSitemapPostQuery = get(
        currentState,
        'htmlSitemapPost.data.query.queryString'
      );
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        htmlSitemapPostQuery,
        'htmlSitemapPostPage'
      );

      return {
        isLoading: false,
        data: action.htmlSitemapPostPage,
        ads: adModelData
      };
    },
    HTML_SITEMAP_POST_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.htmlSitemapPostPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
